import { useQueryClient } from 'react-query'

import { useToast } from '@wartek-id/toast-v2'

import { useAPIUpsertSKP, apiPaths } from 'api/kinerja/useAPIKinerja'
import { useGetKinerjaQuerykeys } from 'api/kinerja/utils/api'

import type { UpsertSKPPayload } from 'types/kinerja'

/**
 * @deprecated use `useUpsertPerencanaanPegawai` instead
 * @see {@link https://github.com/wartek-id/kinerja-web/blob/main/app/KinerjaShared/hooks/useUpsertPerencanaanPegawai.ts}
 */
export const useUpsertPerencanaan = () => {
  const toast = useToast()
  const queryClient = useQueryClient()
  const perencanaanDataQueryKey = useGetKinerjaQuerykeys(apiPaths.kinerja())
  const updateSKPMutation = useAPIUpsertSKP()

  const handleUpsertMutation = (
    payload: UpsertSKPPayload,
    options?: {
      skip?: boolean
      errorMessage?: string
      successMessage?: string
      shouldInvalidateCache?: boolean
      shouldShowSuccessMessage?: boolean
      onSuccess?: () => void
    }
  ) => {
    // If there is no change, just invoke the success callback
    if (options?.skip) {
      options?.onSuccess?.()
      return
    }

    // Do the perencanaan mutation
    updateSKPMutation.mutate(payload, {
      onSuccess: () => {
        // Show success toast message if needed
        if (options?.shouldShowSuccessMessage) {
          toast({
            message: options?.successMessage || 'Berhasil simpan draf!',
            type: 'success',
          })
        }

        // Invalidate cache if needed
        if (options?.shouldInvalidateCache) {
          queryClient.invalidateQueries(perencanaanDataQueryKey)
        }

        // Invoke success callback if any
        options?.onSuccess?.()
      },
      onError: () => {
        // Show error toast message
        toast({
          message: options?.errorMessage || 'Gagal simpan draf!',
        })
      },
    })
  }

  return {
    handleUpsertMutation,
    isLoading: updateSKPMutation.isLoading,
  }
}
